/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResetPasswordPatient } from '../models/ResetPasswordPatient';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ResetPasswordService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ResetPasswordPatient
     * @throws ApiError
     */
    public resetPasswordCreate({
        requestBody,
    }: {
        requestBody: ResetPasswordPatient,
    }): CancelablePromise<ResetPasswordPatient> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/reset-password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
